// ============= Imports =============
import React from 'react';
import type { VisualPromptDefinition } from '@/types/visualPrompts/visualPrompt.types';
import { CompactVisualPromptCard } from '../CompactVisualPromptCard';
import { Grid } from './styles';

export interface CompactVisualPromptCardGridProps {
  prompts: VisualPromptDefinition[];
  onSelectPrompt: (definition: VisualPromptDefinition) => void;
  onDeletePrompt?: (definition: VisualPromptDefinition) => void;
  onToggleFeatured?: (definition: VisualPromptDefinition) => void;
  disabled?: boolean;
}

// ============= Component =============
export const CompactVisualPromptCardGrid: React.FC<
  CompactVisualPromptCardGridProps
> = ({
  prompts,
  onSelectPrompt,
  onDeletePrompt,
  onToggleFeatured,
  disabled,
}) => (
  <Grid>
    {prompts.map((definition) => (
      <CompactVisualPromptCard
        key={definition.id}
        definition={definition}
        onSelect={onSelectPrompt}
        onDelete={onDeletePrompt}
        onToggleFeatured={onToggleFeatured}
        disabled={disabled}
      />
    ))}
  </Grid>
);
